<script lang="ts">
	import { createEventDispatcher } from "svelte";

	export let orientation, defaultstyle, buttonStyle, mapping
	export let button: string;

	const dispatch = createEventDispatcher();
	function pressButton(uod: string) {
		dispatch('message', {
			event: button,
			value: uod
		})
	}
</script>


<div class="t_recess {orientation} {defaultstyle ? 'shadow' : 'glass'} t_recess-{buttonStyle}" id="trigger_{ mapping }">

	<button value={button} class="trigger shadow button-{buttonStyle}"
		on:mousedown|preventDefault={() => pressButton('down')}
		on:touchstart|preventDefault={() => pressButton('down')}
		on:mouseup|preventDefault={() => pressButton('up')}
		on:touchend|preventDefault={() => pressButton('up')}
	>
		<div class="label">{mapping}</div>
	</button>

</div>


<style>
	#trigger_Start {
		/* border: 1px solid red !important; */
	}
	/* Base button styles*/
	.trigger, .button, .label {
		transition: all 0.2s;
	}
	.trigger:active {
		background-color: #fff !important;
		box-shadow: inset 0 -1px 0px rgb(0 0 0 / 30%) !important;
	}

	/* Default theme */
	.t_recess-default {
		box-shadow:none;
		box-shadow: inset 0 10px 15px rgb(0 0 0 / 30%);
	}
	.button-default {
		box-shadow:none;
		background-color: rgba(0,0,0,0);
		border: 1.5px solid rgba(255,255,255,1);
	}
	.button-default div.label {
		color: rgba(255,255,255,0.75);
	}

	/* Xbox Theme */
	.t_recess-colour {
		/* background: linear-gradient(0deg, rgba(255,255,255,0.1) 30%, rgba(0,0,0,0.2) 70%); */
		background: rgba(0,0,0,0);
		box-shadow: none !important;
	}
	.button-colour {
		color: rgba(255, 255, 255, 0.25);
		background: linear-gradient(0deg, rgba(50,50,50,1) 0%, rgba(0,0,0,1) 90%, rgba(60,60,60,1) 100%);
		box-shadow: inset 0 -4px 0px rgb(0 0 0 / 30%);
	}
	.button-colour div.label {
		margin-top: -6%;
	}
	.button-colour:active div.label {
		margin-top: 0%;
	}

	/* MTN Theme */
	.t_recess-mtn {
		background-color: rgba(255,255,255,0);
		box-shadow: none !important;
	}
	.button-mtn {
		color: #ffc107;
		background-color: rgba(0,0,0,0.75);
		border: 2px solid rgba(255, 255, 255, 0.15);
		box-shadow: none !important;
	}

	/* Orientations */
	.T { top: 10px; }
	.B { bottom: 10px; }
	.L { left: 10px; }
	.R { right: 10px; }

	.TM { top: 15%; }
	.BM { bottom: 15%; }
	.LM { left: 15%; }
	.RM { right: 15%; }
</style>
